import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import RatingStars from "../../components/common/RatingStars/RatingStars";
import { useServiceReviews } from "../../Hooks/useServices";
import ProgressBar from "../../components/common/ProgressBar/ProgressBar";
import ReviewSubmissionForm from "../../components/common/ReviewForm/ReviewSubmissionForm";
import { useLocation } from "react-router-dom";
import SpecialText from "../../components/common/Typography/SpecialText";
import AuxiliaryText from "../../components/common/Typography/AuxiliaryText";
import Heading from "../../components/common/Typography/Heading";
import SpecailStars from "../../components/common/RatingStars/SpecailStars";
import Paragraph from "../../components/common/Typography/Paragraph";
import MainButton from "../../components/common/MainButton/MainButton";
import ReviewForm from "../../components/ReviewForm/ReviewForm";
import useAuth from "../../Hooks/useAuth";
import { useDispatch } from 'react-redux';
import { setRedirectPath } from '../../Redux/Slice/authRedirectSlice';
import { useLoginActionService, LOGIN_SCENARIOS } from '../../services/LoginActionService';


const PosterRanking = forwardRef(({
  data,
  ListingId,
  AuthnicateData,
  listRating,
  showMe,
  show,
  onFilterChange,
  activeFilter,
  isOwnProfile = false,
  isCustomer = false,
  onReviewClick,
  onShareReviewClick,
}, ref) => {
  const getReactionInfo = AuthnicateData?.data?.$values.find(
    (e) => e.id?.toString() === ListingId.toString()
  );
  const location = useLocation();
  const { data: reviewsData, status } = useServiceReviews(ListingId);
  const [ReviewsList, setReviewsList] = useState();
  const [reviewFormOpen, setReviewFormOpen] = useState(false);
  const [pendingReview, setPendingReview] = useState(false);
  const { auth } = useAuth();
  const dispatch = useDispatch();
  const loginActionService = useLoginActionService();

  // Function to open review form - exposed via ref
  const openReviewForm = () => {
    setReviewFormOpen(true);
  };

  // Expose methods via ref
  useImperativeHandle(ref, () => ({
    openReviewForm
  }));
  
  useEffect(() => {
    const sortOrderByDescbyRating = (List) => {
      let sortedDsc = List?.sort((a, b) => {
        return parseInt(b.starRating) - parseInt(a.starRating);
      });
      return sortedDsc;
    };
    setReviewsList(sortOrderByDescbyRating(reviewsData?.data?.key?.$values));
  }, [ListingId, reviewsData]);

  // Handle automatic review form opening after login redirect
  useEffect(() => {
    if (auth?.user && pendingReview) {
      setReviewFormOpen(true);
      setPendingReview(false);
    }
  }, [auth?.user, pendingReview]);
  
  // Static demo data for reviews and ratings
  const staticReviews = 35;
  const staticOverall = 4.3;
  
  // Calculate filtered review count
  const getFilteredReviewCount = () => {
    if (!activeFilter) return staticReviews;
    const filteredData = dataList.find(item => item.value === activeFilter);
    return filteredData ? filteredData.count : 0;
  };
  const dataList = [
    {
      heading: "Communication",
      number: 5,
      percent: 100,
      value: 5,
      count: 15,
    },
    {
      heading: "Reliability",
      number: 4,
      percent: 80,
      value: 4,
      count: 12,
    },
    {
      heading: "Satisfaction",
      number: 3,
      percent: 60,
      value: 3,
      count: 5,
    },
    {
      heading: "Recommend",
      number: 2,
      percent: 40,
      value: 2,
      count: 2,
    },
    {
      heading: "Punctuality",
      number: 1,
      percent: 20,
      value: 1,
      count: 1,
    },
  ];

  const handleFilterClick = (starRating) => {
    if (onFilterChange) {
      onFilterChange(activeFilter === starRating ? null : starRating);
    }
  };

  const handleShareReviewLink = () => {
    // This will be handled by the parent component (ProfileMainContainer)
    // to open the SharePopup with the review URL
    if (onShareReviewClick) {
      onShareReviewClick();
    }
  };

  return (
    <>
      {/* Review Form Popup */}
      <ReviewForm
        isOpen={reviewFormOpen}
        onClose={() => setReviewFormOpen(false)}
        businessData={data}
      />
      
      <div
        className={
          location?.pathname?.includes("customer-dashboard") ||
          location?.pathname?.includes("business-dashboard") ||
          location?.pathname?.includes("poster-profile")
            ? "max-w-full md:max-w-full xl:max-w-full 2xl:max-w-full bg-white text-offblack rounded-xl py-16 px-10"
            : "max-w-full md:max-w-full xl:max-w-full 2xl:max-w-full bg-white text-offblack rounded-xl py-16 px-10"
        }
      >
        {/* {!show && (
          <div className="flex justify-center mt-5 xl:mt-10">
            <div className="flex flex-col w-full md:w-[468px]">
              <Heading
                variant={"h6"}
                className={
                  "flex justify-center text-offblack uppercase md:normal-case"
                }
              >
                Write a review
              </Heading>
              <div className="flex justify-center mt-3"> */}
                {/* <span onClick={() => setForm(!form)}> */}
                {/* <span>
                  <SpecailStars rating={5} className={"size-5 sm:size-4"} />
                </span>
              </div>
            </div>
          </div>
        )} */}
        <div className="">
          <div className="grid grid-cols-12 items-center xl:mx-5">
            <div className="col-span-5 md:col-span-6 mr-[15px] xl:mr-[20px]">
              <div className="flex items-center justify-between">
                <Paragraph variant={"MainParagraph"}>
                  {activeFilter ? `${activeFilter}-Star Reviews` : "Reviews"}
                </Paragraph>
                <SpecialText variant={"number-xl"}>{getFilteredReviewCount().toLocaleString()}</SpecialText>
              </div>
            </div>
            <div className="col-span-3 md:col-span-3">
              <div
                className={
                  location?.pathname?.includes("customer-dashboard") ||
                  location?.pathname?.includes("business-dashboard")
                    ? "ml-2 md:ml-10"
                    : "ml-2 md:ml-10"
                }
              >
                <Paragraph variant={"MainParagraph"}>
                  Overall rating
                </Paragraph>
              </div>
            </div>
            <div className="col-span-4 md:col-span-3 flex justify-end">
              <span className="flex items-center gap-2">
                <div className="flex justify-center">
                  <SpecialText variant={"number-xl"}>{staticOverall}</SpecialText>
                </div>
              </span>
            </div>
          </div>
          <div className="mt-5">
            {dataList.map((e, index) => {
              const isActive = activeFilter === e.value;
              return (
                <div
                  key={index}
                  className={`grid grid-cols-12 items-center h-4 mb-3 xl:mx-5 cursor-pointer transition-all duration-200`}
                  onClick={() => handleFilterClick(e.value)}
                >
                  <div className="col-span-5 md:col-span-6 mr-[15px] xl:mr-[20px]">
                    <ProgressBar
                      number={e.number}
                      percent={e.percent}
                      className={"h-3"}
                      counter={e.count}
                    />
                  </div>
                  <div className="col-span-3 md:col-span-2">
                    <div className={"ml-2 md:ml-10"}>
                      <SpecialText variant={"Counter"}>
                        {e.heading}
                      </SpecialText>
                    </div>
                  </div>
                  <div className="col-span-4 md:col-span-4 flex justify-end">
                    <span className="flex items-center">
                      <RatingStars
                        rating={e.value}
                      />
                      <SpecialText variant={"Counter"} className="w-2 text-center">{e.value}</SpecialText>
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="flex justify-center mt-16">
          <MainButton 
            variant="outlinemedium" 
            onClick={() => {
              if (isOwnProfile || !isCustomer) {
                handleShareReviewLink();
              } else {
                loginActionService.handleLoginTrigger(LOGIN_SCENARIOS.PROFILE_WRITE_REVIEW.id, {
                  setSignIn: onReviewClick,
                  currentPath: location.pathname + location.search,
                  auth,
                  setPopupOpen: openReviewForm,
                  popupData: { profileData: data }
                });
              }
            }}
          >
            {isOwnProfile || !isCustomer ? (
              "Share Review Link"
            ) : (
              "Write a review"
            )}
          </MainButton>
        </div>
        
        {/* Removed floating notification */}
      </div>
         </>
   );
 });

export default PosterRanking;
